import dynamic from 'next/dynamic';
import { FC } from 'react';
import { AnyAction, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RootState } from 'store/types';

import { isAuthenticatedSelector } from '../../../../duck';
import { claimProfile, isValidItpProSelector, proNameSelector } from '../../duck';
const ProfileClaim = dynamic(
  () => import(/* webpackChunkName: "profile-claim" */ './ProfileClaim')
);

type ReduxProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const ProfileClaimContainer: FC<ReduxProps> = ({ isAuthenticated, validItp, ...props }) =>
  isAuthenticated && validItp ? <ProfileClaim {...props} /> : null;

const mapStateToProps = (state: RootState) => ({
  isAuthenticated: isAuthenticatedSelector(state) as boolean,
  proName: proNameSelector(state) as string,
  validItp: isValidItpProSelector(state) as boolean,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  claimProfile: (email: string) => dispatch(claimProfile(email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileClaimContainer);
